export default __webpack_public_path__ + "static/media/tides-logo.84281658.png";